document.documentElement.classList.add('js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    const open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!open));
    menu.hidden = open;
  }
});

function setupMagicalEffects(scope = document) {
  scope.querySelectorAll('[data-magical-effects]').forEach((layer) => {
    if (layer.dataset.magicReady === 'true') return;
    layer.dataset.magicReady = 'true';

    const anchor = layer.closest('[data-magic-anchor]');
    const target = layer.dataset.magicTarget;
    if (anchor && target && target !== 'self') {
      let host;
      if (target === 'previous') host = anchor.parentElement?.previousElementSibling;
      if (target === 'next') host = anchor.parentElement?.nextElementSibling;
      if (target === 'page') host = document.body;
      if (host) {
        host.classList.add('magic-host');
        host.append(layer);
      }
    } else {
      layer.parentElement?.classList.add('magic-host');
    }

    layer.querySelectorAll('[data-magic-particles]').forEach((field) => {
      const total = Math.min(Number(field.dataset.count) || 0, 40);
      const kind = field.dataset.magicParticles;
      for (let index = 0; index < total; index += 1) {
        const particle = document.createElement('i');
        const x = (index * 47 + 11) % 97;
        const y = (index * 67 + 23) % 91;
        const delay = -((index * 1.37) % 12);
        const duration = 7 + ((index * 3) % 9);
        const scale = 0.65 + ((index * 13) % 10) / 10;
        const color = kind === 'fairy' ? index % 4 : 0;
        particle.style.cssText = `--x:${x}%;--y:${y}%;--delay:${delay}s;--duration:${duration}s;--scale:${scale};--color-index:${color}`;
        field.append(particle);
      }
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches && document.body.classList.contains('magic-respect-reduced-motion')) {
      layer.querySelectorAll('video').forEach((video) => video.pause());
    }
  });
}

document.addEventListener('DOMContentLoaded', () => setupMagicalEffects());
document.addEventListener('shopify:section:load', (event) => setupMagicalEffects(event.target));

document.addEventListener('DOMContentLoaded', () => {
  const faq = document.querySelector('.page-content--faq');
  if (!faq) return;
  const headings = [...faq.querySelectorAll(':scope > h2')];
  if (!headings.length) return;
  const list = document.createElement('div');
  list.className = 'faq-list faq-list--page';
  headings.forEach((heading) => {
    const details = document.createElement('details');
    const summary = document.createElement('summary');
    summary.textContent = heading.textContent;
    details.append(summary);
    let next = heading.nextSibling;
    while (next && !(next.nodeType === 1 && next.tagName === 'H2')) {
      const moving = next;
      next = next.nextSibling;
      details.append(moving);
    }
    heading.remove();
    list.append(details);
  });
  faq.append(list);
});

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.options[select.selectedIndex];
  const price = document.querySelector('[data-product-price]');
  const button = document.querySelector('[data-product-submit]');
  const status = document.querySelector('[data-product-status]');
  const quantity = document.querySelector('.product-form input[name="quantity"]');
  if (price) price.textContent = option.dataset.price;
  if (status) status.textContent = option.dataset.available === 'true' ? 'Available' : 'Sold out';
  if (quantity) {
    const inventory = Number(option.dataset.inventory);
    if (inventory > 0) quantity.max = String(inventory);
    else quantity.removeAttribute('max');
  }
  if (button) {
    button.disabled = option.dataset.available !== 'true';
    button.textContent = option.dataset.available === 'true' ? 'Add to cart' : 'Sold out';
  }
});

function setupGrimoire(root) {
  if (!root || root.dataset.grimoireReady === 'true') return;
  root.dataset.grimoireReady = 'true';

  const input = root.querySelector('[data-grimoire-search]');
  const items = [...root.querySelectorAll('[data-crystal-card]')];
  const modeButtons = [...root.querySelectorAll('[data-grimoire-mode]')];
  const panels = [...root.querySelectorAll('[data-grimoire-panel]')];
  const categoryButtons = [...root.querySelectorAll('[data-grimoire-category]')];
  const colorButtons = [...root.querySelectorAll('[data-grimoire-color]')];
  const letterButtons = [...root.querySelectorAll('[data-grimoire-letter]')];
  const clearButton = root.querySelector('[data-grimoire-clear]');
  const count = root.querySelector('[data-grimoire-count]');
  const empty = root.querySelector('[data-grimoire-empty]');
  let activeMode = 'photos';
  let activeCategory = '';
  let activeColor = '';
  let activeLetter = '';

  const tokensFor = (value) => (value || '')
    .split(/[\s,]+/)
    .map((token) => token.trim())
    .filter(Boolean);

  const normalize = (value) => value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const editDistance = (left, right) => {
    const previous = Array.from({ length: right.length + 1 }, (_, index) => index);
    for (let row = 1; row <= left.length; row += 1) {
      const current = [row];
      for (let column = 1; column <= right.length; column += 1) {
        current[column] = Math.min(
          current[column - 1] + 1,
          previous[column] + 1,
          previous[column - 1] + (left[row - 1] === right[column - 1] ? 0 : 1)
        );
      }
      previous.splice(0, previous.length, ...current);
    }
    return previous[right.length];
  };

  const forgivingMatch = (haystack, query) => {
    const normalizedHaystack = normalize(haystack);
    const normalizedQuery = normalize(query);
    if (!normalizedQuery || normalizedHaystack.includes(normalizedQuery)) return true;
    const choices = normalizedHaystack.split(' ').filter(Boolean);
    return normalizedQuery.split(' ').filter(Boolean).every((needle) => choices.some((choice) => {
      if (choice.includes(needle)) return true;
      if (needle.length < 3 || choice[0] !== needle[0]) return false;
      const tolerance = needle.length >= 6 ? 2 : 1;
      return Math.abs(choice.length - needle.length) <= tolerance && editDistance(choice, needle) <= tolerance;
    }));
  };

  const updateMode = () => {
    modeButtons.forEach((button) => {
      const selected = button.dataset.grimoireMode === activeMode;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-selected', String(selected));
    });
    panels.forEach((panel) => { panel.hidden = panel.dataset.grimoirePanel !== activeMode; });
  };

  const applyFilters = () => {
    const query = (input?.value || '').trim();
    let visible = 0;

    items.forEach((item) => {
      const matchesSearch = forgivingMatch(item.dataset.crystalSearch || '', query);
      const matchesCategory = !activeCategory || tokensFor(item.dataset.crystalCategories).includes(activeCategory);
      const matchesColor = !activeColor || tokensFor(item.dataset.crystalColors).includes(activeColor);
      const matchesLetter = !activeLetter || item.dataset.crystalLetter === activeLetter;
      const matches = matchesSearch && matchesCategory && matchesColor && matchesLetter;
      item.hidden = !matches;
      if (matches) visible += 1;
    });

    categoryButtons.forEach((button) => {
      const selected = button.dataset.grimoireCategory === activeCategory;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    colorButtons.forEach((button) => {
      const selected = button.dataset.grimoireColor === activeColor;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    letterButtons.forEach((button) => {
      const selected = button.dataset.grimoireLetter === activeLetter;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });

    if (count) count.textContent = `${visible} crystal${visible === 1 ? '' : 's'}`;
    if (empty) empty.hidden = visible !== 0;
    if (clearButton) clearButton.hidden = !query && !activeCategory && !activeColor && !activeLetter;
  };

  input?.addEventListener('input', applyFilters);
  modeButtons.forEach((button) => button.addEventListener('click', () => {
    activeMode = button.dataset.grimoireMode || 'photos';
    activeCategory = '';
    activeColor = '';
    activeLetter = '';
    updateMode();
    applyFilters();
  }));
  categoryButtons.forEach((button) => button.addEventListener('click', () => {
    const selected = button.dataset.grimoireCategory;
    activeCategory = activeCategory === selected ? '' : selected;
    activeColor = '';
    activeLetter = '';
    applyFilters();
    root.querySelector('.grimoire-directory')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));
  colorButtons.forEach((button) => button.addEventListener('click', () => {
    const selected = button.dataset.grimoireColor;
    activeColor = activeColor === selected ? '' : selected;
    activeCategory = '';
    activeLetter = '';
    applyFilters();
    root.querySelector('.grimoire-directory')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));
  letterButtons.forEach((button) => button.addEventListener('click', () => {
    activeLetter = button.dataset.grimoireLetter || '';
    activeCategory = '';
    activeColor = '';
    applyFilters();
  }));
  clearButton?.addEventListener('click', () => {
    if (input) input.value = '';
    activeMode = 'photos';
    activeCategory = '';
    activeColor = '';
    activeLetter = '';
    updateMode();
    applyFilters();
    input?.focus();
  });

  root.addEventListener('click', (event) => {
    const colorLink = event.target.closest('[data-crystal-color-link]');
    if (colorLink) {
      activeMode = 'color';
      activeColor = colorLink.dataset.crystalColorLink || '';
      activeCategory = '';
      activeLetter = '';
      colorLink.closest('[data-crystal-dialog]')?.close();
      updateMode();
      applyFilters();
      root.querySelector('.grimoire-directory')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    const opener = event.target.closest('[data-crystal-open]');
    if (opener) document.getElementById(opener.dataset.crystalOpen)?.showModal();
    const closer = event.target.closest('[data-crystal-close]');
    if (closer) closer.closest('[data-crystal-dialog]')?.close();
    if (event.target.matches('[data-crystal-dialog]')) event.target.close();
  });

  updateMode();
  applyFilters();
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-grimoire]').forEach(setupGrimoire);
});

document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.matches?.('[data-grimoire]') ? event.target : event.target.querySelector?.('[data-grimoire]');
  setupGrimoire(root);
});

document.addEventListener('click', (event) => {
  const mediaThumb = event.target.closest('[data-media-thumb]');
  if (mediaThumb) {
    const gallery = mediaThumb.closest('[data-media-gallery]');
    const index = mediaThumb.dataset.mediaThumb;
    gallery?.querySelectorAll('[data-media-slide]').forEach((slide) => {
      const active = slide.dataset.mediaSlide === index;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
      if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
    });
    gallery?.querySelectorAll('[data-media-thumb]').forEach((button) => button.classList.toggle('is-active', button === mediaThumb));
  }

  const productThumb = event.target.closest('[data-product-media-thumb]');
  if (productThumb) {
    const gallery = productThumb.closest('[data-product-gallery]');
    const index = productThumb.dataset.productMediaThumb;
    gallery?.querySelectorAll('[data-product-media-slide]').forEach((slide) => {
      const active = slide.dataset.productMediaSlide === index;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
      if (!active) slide.querySelectorAll('video').forEach((video) => video.pause());
    });
    gallery?.querySelectorAll('[data-product-media-thumb]').forEach((button) => button.classList.toggle('is-active', button === productThumb));
    const dialogImage = gallery?.querySelector('[data-gallery-dialog-image]');
    if (dialogImage && productThumb.dataset.imageSrc) {
      dialogImage.src = productThumb.dataset.imageSrc;
      dialogImage.alt = productThumb.dataset.imageAlt || '';
    }
  }

  const thumb = event.target.closest('[data-gallery-thumb]');
  if (thumb) {
    const gallery = thumb.closest('[data-product-gallery]');
    const main = gallery?.querySelector('[data-gallery-main]');
    const dialogImage = gallery?.querySelector('[data-gallery-dialog-image]');
    if (main) {
      main.src = thumb.dataset.imageSrc;
      main.srcset = '';
      main.alt = thumb.dataset.imageAlt;
    }
    if (dialogImage) {
      dialogImage.src = thumb.dataset.imageSrc;
      dialogImage.alt = thumb.dataset.imageAlt;
    }
    gallery?.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.classList.toggle('is-active', button === thumb));
  }

  const open = event.target.closest('[data-gallery-open]');
  if (open) open.closest('[data-product-gallery]')?.querySelector('[data-gallery-dialog]')?.showModal();

  const close = event.target.closest('[data-gallery-close]');
  if (close) close.closest('[data-gallery-dialog]')?.close();

  const eventLightboxOpen = event.target.closest('[data-event-lightbox-open]');
  if (eventLightboxOpen) document.getElementById(eventLightboxOpen.dataset.eventLightboxOpen)?.showModal();

  const lightboxClose = event.target.closest('[data-media-lightbox-close]');
  if (lightboxClose) lightboxClose.closest('dialog')?.close();

  const mediaZoom = event.target.closest('[data-media-lightbox]');
  if (mediaZoom) {
    const source = mediaZoom.querySelector('img');
    if (!source) return;
    let dialog = document.querySelector('[data-runtime-media-lightbox]');
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'media-lightbox';
      dialog.dataset.runtimeMediaLightbox = 'true';
      dialog.innerHTML = '<button class="media-lightbox__close" type="button" data-media-lightbox-close aria-label="Close enlarged image">×</button><img alt="">';
      document.body.append(dialog);
    }
    const image = dialog.querySelector('img');
    image.src = source.currentSrc || source.src;
    image.alt = source.alt;
    dialog.showModal();
  }

  if (event.target.matches('[data-media-lightbox-dialog], [data-runtime-media-lightbox]')) event.target.close();
});

function setupEventCalendars(scope = document) {
  const calendars = [...scope.querySelectorAll('[data-event-calendar]')];

  const compactDate = (value) => (value || '').replace(/-/g, '');
  const addDays = (value, days) => {
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day + days));
    return [date.getUTCFullYear(), String(date.getUTCMonth() + 1).padStart(2, '0'), String(date.getUTCDate()).padStart(2, '0')].join('-');
  };
  const compactTime = (value) => {
    const match = (value || '').trim().match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?\s*(AM|PM)?$/i);
    if (!match) return '';
    let hour = Number(match[1]);
    const minute = match[2];
    const second = match[3] || '00';
    const meridiem = match[4]?.toUpperCase();
    if (meridiem === 'AM' && hour === 12) hour = 0;
    if (meridiem === 'PM' && hour < 12) hour += 12;
    return `${String(hour).padStart(2, '0')}${minute}${second}`;
  };
  const escapeIcs = (value) => (value || '')
    .replace(/\\/g, '\\\\')
    .replace(/\r?\n/g, '\\n')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;');
  const foldIcsLine = (line) => {
    const encoder = new TextEncoder();
    const folded = [];
    let current = '';
    for (const character of line) {
      if (encoder.encode(current + character).length > 73) {
        folded.push(current);
        current = ` ${character}`;
      } else {
        current += character;
      }
    }
    folded.push(current);
    return folded.join('\r\n');
  };
  const safeFilename = (value) => (value || 'enchanted-bell-event')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  calendars.forEach((calendar) => {
    if (calendar.dataset.calendarReady === 'true') return;
    calendar.dataset.calendarReady = 'true';

    const data = calendar.dataset;
    const startDate = data.calendarStartDate;
    const endDate = data.calendarEndDate || startDate;
    const startTime = compactTime(data.calendarStartTime);
    const endTime = compactTime(data.calendarEndTime);
    const isAllDay = !startTime || !endTime;
    const descriptionSource = calendar.querySelector('[data-calendar-description-source]')?.content;
    const descriptionParagraphs = descriptionSource ? [...descriptionSource.querySelectorAll('p, li')]
      .map((element) => element.textContent.trim())
      .filter(Boolean) : [];
    const sourceDescription = descriptionParagraphs.length
      ? [...new Set(descriptionParagraphs)].join('\n')
      : descriptionSource?.textContent?.trim() || '';
    const calendarDescription = [sourceDescription, data.calendarDescription].filter(Boolean).join('\n\n');
    const exclusiveEndDate = addDays(endDate, 1);
    const googleDates = isAllDay
      ? `${compactDate(startDate)}/${compactDate(exclusiveEndDate)}`
      : `${compactDate(startDate)}T${startTime}/${compactDate(endDate)}T${endTime}`;
    const googleParameters = new URLSearchParams({
      action: 'TEMPLATE',
      text: data.calendarTitle || '',
      dates: googleDates,
      details: calendarDescription,
      location: data.calendarLocation || '',
      ctz: data.calendarTimeZone || 'America/New_York'
    });
    const googleLink = calendar.querySelector('[data-calendar-google]');
    if (googleLink) googleLink.href = `https://calendar.google.com/calendar/render?${googleParameters}`;

    const buildIcs = () => {
      const now = new Date().toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
      const lines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//The Enchanted Bell//Events//EN',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH'
      ];

      if (!isAllDay) {
        lines.push(
          'BEGIN:VTIMEZONE',
          `TZID:${data.calendarTimeZone}`,
          `X-LIC-LOCATION:${data.calendarTimeZone}`,
          'BEGIN:DAYLIGHT',
          'TZOFFSETFROM:-0500',
          'TZOFFSETTO:-0400',
          'TZNAME:EDT',
          'DTSTART:19700308T020000',
          'RRULE:FREQ=YEARLY;BYMONTH=3;BYDAY=2SU',
          'END:DAYLIGHT',
          'BEGIN:STANDARD',
          'TZOFFSETFROM:-0400',
          'TZOFFSETTO:-0500',
          'TZNAME:EST',
          'DTSTART:19701101T020000',
          'RRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU',
          'END:STANDARD',
          'END:VTIMEZONE'
        );
      }

      lines.push(
        'BEGIN:VEVENT',
        `UID:${escapeIcs(data.calendarId)}@enchantedbell.com`,
        `DTSTAMP:${now}`,
        isAllDay
          ? `DTSTART;VALUE=DATE:${compactDate(startDate)}`
          : `DTSTART;TZID=${data.calendarTimeZone}:${compactDate(startDate)}T${startTime}`,
        isAllDay
          ? `DTEND;VALUE=DATE:${compactDate(exclusiveEndDate)}`
          : `DTEND;TZID=${data.calendarTimeZone}:${compactDate(endDate)}T${endTime}`,
        `SUMMARY:${escapeIcs(data.calendarTitle)}`,
        `DESCRIPTION:${escapeIcs(calendarDescription)}`,
        `LOCATION:${escapeIcs(data.calendarLocation)}`,
        'STATUS:CONFIRMED',
        'TRANSP:OPAQUE',
        'END:VEVENT',
        'END:VCALENDAR'
      );
      return `${lines.map(foldIcsLine).join('\r\n')}\r\n`;
    };

    calendar.addEventListener('click', (event) => {
      const downloadButton = event.target.closest('[data-calendar-download]');
      if (!downloadButton) return;
      const blob = new Blob([buildIcs()], { type: 'text/calendar;charset=utf-8' });
      const objectUrl = URL.createObjectURL(blob);
      const downloadLink = document.createElement('a');
      downloadLink.href = objectUrl;
      downloadLink.download = `${safeFilename(data.calendarTitle)}.ics`;
      document.body.append(downloadLink);
      downloadLink.click();
      downloadLink.remove();
      window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
      const status = calendar.querySelector('[data-calendar-status]');
      if (status) status.textContent = `Calendar file downloaded for ${data.calendarTitle}.`;
      calendar.open = false;
    });
  });
}

document.addEventListener('DOMContentLoaded', () => setupEventCalendars());
document.addEventListener('shopify:section:load', (event) => setupEventCalendars(event.target));
